import { SessionStorageTtlStore } from 'src/utils/sessionStorageTtlStore';
import { User } from 'switch-shared/modules/crud/user/user.entity';
import { TtlCache } from 'switch-shared/utils/ttl-cache';

const SWITCH_USER_CACHE_TTL_MS = 2 * 60 * 1000;

const cache = new TtlCache<User>({
  ttlMs: SWITCH_USER_CACHE_TTL_MS,
  store: new SessionStorageTtlStore<User>('admin-console:switch-user:v1'),
});

const SLOT = 'current';

export const readSwitchUserCache = (firebaseUid: string): User | null =>
  cache.get(SLOT, { scope: firebaseUid }) ?? null;

export const writeSwitchUserCache = (firebaseUid: string, user: User) => {
  cache.set(SLOT, user, { scope: firebaseUid });
};

export const clearSwitchUserCache = () => {
  cache.clear();
};
